var map = {
	"./logo-darkfans-black-white.svg": "7583",
	"./logo-darkfans-black.svg": "02a0",
	"./logo-darkfans-white.svg": "9047",
	"./logo-loverfans-black-white.svg": "73f9",
	"./logo-loverfans-black.svg": "313d",
	"./logo-loverfans-color.svg": "81d0",
	"./logo-loverfans-white.svg": "b95f",
	"./logo-scatbook-black-white.svg": "de24",
	"./logo-scatbook-black.svg": "7101",
	"./logo-scatbook-color.svg": "76499",
	"./logo-scatbook-white.svg": "f8dc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "30b3";